import React from 'react';
import { MessageCircleIcon, XIcon } from 'lucide-react';
import { painRows, sundayStruggles } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-white py-10 sm:py-20" aria-labelledby="problem-heading" data-id="element-194" data-mp="2lq8i4srgzwhu">
      <div className="mx-auto max-w-3xl px-5 sm:px-6" data-id="element-195" data-mp="30j0u9a7mgp57">
        <h2 id="problem-heading" className="flex items-center justify-center gap-3 text-center font-display text-2xl font-bold text-navy sm:text-4xl" data-id="element-196" data-mp="2vpg1pxossnde">
          <MessageCircleIcon className="h-6 w-6 text-gold-text sm:h-7 sm:w-7" strokeWidth={2} aria-hidden="true" data-id="element-197" data-mp="35gas9e92u94n" />
          Does This Sound Familiar?
        </h2>

        <div className="mt-6 rounded-2xl border border-line bg-canvas p-5 sm:mt-8 sm:p-8" data-id="element-198" data-mp="3jfjxxjznpkud">
          <p className="text-base font-semibold text-navy sm:text-lg" data-id="element-199" data-mp="3eia6jyspiz3w">
            Sunday, 6 PM. Training tomorrow. You’re still:
          </p>
          <ul className="mt-3 space-y-1.5" data-id="element-200" data-mp="1k2xy2xh16a4s">
            {sundayStruggles.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-body sm:text-base" data-id="element-201" data-mp="1k4slqjjosgck">
                <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-text" aria-hidden="true" data-id="element-202" data-mp="jbafr5dl3lhu" />
                {item}
              </li>)}
          </ul>
          <p className="mt-4 text-sm leading-relaxed text-body sm:text-base" data-id="element-203" data-mp="sc8kxqzrdz20">
            Not because you lack knowledge —{' '}
            <span className="font-semibold text-navy" data-id="element-204" data-mp="x6ct2dkrgd4o">
              but because structuring multiple events takes time you don’t
              have.
            </span>
          </p>
        </div>

        <h3 className="mt-10 text-center font-display text-xl font-bold text-navy sm:text-2xl" data-id="element-205" data-mp="174sk6gjsfme6">
          The Real Cost of Not Having a Complete System
        </h3>
        <div className="mt-6 overflow-hidden rounded-xl border border-line" data-id="element-206" data-mp="1g22xs8k2vnm9">
          <table className="w-full border-collapse text-left" data-id="element-207" data-mp="3dtxg7xektcdd">
            <thead className="bg-navy" data-id="element-208" data-mp="3dviarn0w4vb8">
              <tr data-id="element-209" data-mp="3htza3ke2l1i3">
                <th scope="col" className="w-1/2 px-4 py-3 text-xs font-bold uppercase tracking-wider text-white" data-id="element-210" data-mp="3hv98kaou4bp9">
                  The problem
                </th>
                <th scope="col" className="w-1/2 border-l border-navy-line px-4 py-3 text-xs font-bold uppercase tracking-wider text-white" data-id="element-211" data-mp="k1pbfgl2behf">
                  The real impact
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line bg-white" data-id="element-212" data-mp="txseconqnh5f">
              {painRows.map(row => <tr key={row.problem} data-id="element-213" data-mp="17y38c0kchbut">
                  <th scope="row" className="px-4 py-3.5 align-top text-sm font-medium leading-snug text-navy" data-id="element-214" data-mp="17x1szjwaq37a">
                    <span className="flex items-start gap-2" data-id="element-215" data-mp="1hoy53yv7vtui">
                      <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" strokeWidth={2.5} aria-hidden="true" data-id="element-216" data-mp="1hoenkj9hb7h0" />
                      {row.problem}
                    </span>
                  </th>
                  <td className="border-l border-line px-4 py-3.5 align-top text-sm leading-snug text-body" data-id="element-217" data-mp="1qq5olat2qq4j">
                    {row.impact}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-8 border-t border-line pt-6 text-center" data-id="element-218" data-mp="2abeb7gdnol4v">
          <p className="font-display text-xl font-bold text-navy sm:text-2xl" data-id="element-219" data-mp="2aamrb2tf8buf">
            Stop rebuilding your coaching system{' '}
            <span className="text-gold-text" data-id="element-220" data-mp="20d8edd6pi56v">every single week.</span>
          </p>
          <p className="mt-2 text-base text-body" data-id="element-221" data-mp="20f2wykui9l7s">
            That is not coaching. That is improvising.
          </p>
        </div>
      </div>
    </section>;
}